<template>
  <div class="modal"
       id="modal-cancel-subtest-attempt"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ translate('previews.subtest-attempt.buttons.resolve-' + moduleType + '-cancellation') }}
          </h5>
        </div>

        <div class="modal-body">
          <div class="alert alert-info">
            <span class="fa fa-info-circle"></span> {{ translate('modals.cancel.reason') }}:
            {{ subtestAttempt[moduleType + '_cancellation_reason'] }}
          </div>
        </div>

        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default pull-left"
                  data-dismiss="modal">
            {{ translate('modals.cancel.cancel') }}
          </button>
          <button type="button"
                  class="btn btn-secondary btn-sm"
                  @click.prevent="cancelSubtestAttempt('decline')"
                  :disabled="cancelSubtestAttemptForm.busy">
            {{ translate('modals.cancel.decline') }}
          </button>
          <button type="button"
                  class="btn btn-success btn-sm"
                  @click.prevent="cancelSubtestAttempt('approve')"
                  :disabled="cancelSubtestAttemptForm.busy">
            {{ translate('modals.cancel.approve') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['subtestAttempt', 'moduleType'],

  /**
   * The component's data.
   */
  data () {
    return {
      cancelSubtestAttemptForm: new AppForm({
        action: null,
        type: null
      }),
    };
  },

  methods: {
    /**
     * Cancel the Subtest Attempt.
     */
    cancelSubtestAttempt (action) {
      let self = this;

      this.cancelSubtestAttemptForm.type = this.moduleType;
      this.cancelSubtestAttemptForm.action = action;

      App.put('/api/subtest-attempts/' + this.subtestAttempt.id + '/cancel', this.cancelSubtestAttemptForm)
        .then(() => {
          $('#modal-cancel-subtest-attempt').modal('hide');

          self.cancelSubtestAttemptForm.type = null;
          self.cancelSubtestAttemptForm.action = null;
          self.$parent.$emit('getSubtestAttempt', self.subtestAttempt.id);
        });
    },
  }
};
</script>
